export const selectIsLoggedIn = state => state.auth.isLoggedIn;
export const selectName = state => state.auth.name;
export const selectBalance = state => state.auth.balance;
export const selectIsLoading = state => state.auth.isLoading;
export const selectIsRefreshing = state => state.auth.isRefreshing;
export const selectError = state => state.auth.error;
export const selectEmail = state => state.auth.email;
export const selectFirstVisit = state => state.auth.firstVisit;
export const selectFirstBalance = state => state.auth.firstBalance;
export const selectAccessToken = state => state.auth.accessToken;
export const selectAvatar = state => state.auth.avatarUrl;
